module.exports = __webpack_public_path__ + "static/media/cash-for-junk-car2.74afa30f.png";